module.exports = "<div class=\"form-grid__col form-grid__col8\"> <label class=md-body-1>Notes</label> </div> <md-input-container class=\"form-element form-element--simple form-grid__col\"> <md-select aria-label=Notes ng-model=absdsad> <md-option ng-repeat=\"n in [1,2,3,4]\" ng-value=n>Option {{n}}</md-option> </md-select> </md-input-container> <div class=\"form-grid__col form-grid__col12\"> <md-icon class=\"material-icons material-icons--help\">help</md-icon> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/sensors-and-connectors/components/search/advanced/thing-notes/thing-notes.html
// module id = sL6j
// module chunks = 1